<router-outlet></router-outlet>
<div class="pamoinas-vraperis">
  <app-leaderboard-bets-wrapper [rows]="6"></app-leaderboard-bets-wrapper>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/games.template.html